class Services {
  constructor() {
  }

  getIdentificationUserData(radicado){
    const getIdentificationData = new ServicioProxy('ObtenerDatosVentaVinculacionPorRadicado?numeroRadicado=' + radicado, 'ServicioConsorcio.svc');  
    return new Promise((resolve, reject) => {
      getIdentificationData.getElements('POST', {})
      .then(response => {
        resolve(JSON.parse(response));
      }).catch(error =>  reject(error) ); 
    });
  }

  /*
    Validate Current Step
    JSON Response  { "Error": null, "enPasoValido": true }
  */ 
  validateCurrentStep(isAsesor, page, number){
    const methodByUser = isAsesor ?  `ValidarContinuarProcesoAsesorVsPagina?pagina=${page}` : `ValidarContinuarProcesoClienteVsPagina?pagina=${page}`;
    
    const validateCurrentStep = new ServicioProxy(methodByUser, 'ServicioConsorcio.svc');  
    return new Promise((resolve, reject) => {
      validateCurrentStep.getElements('POST', {})
      .then(response => {
        resolve(JSON.parse(response));
      }).catch(error =>  reject(error) ); 
    });
  }
/*
  getConfigAndParams() {
    const configs = new Promise((resolve, reject) => {
      this.pnpService.getListWithTop('configuraciones', list => {
      const configurations = list.reduce((configuratios, item) => {
        configurations[item.CSNombreText] = item.CSValorNote;
        return configurations;
        } , {});
        resolve(configurations)
      }, 200, ("CSSeccionChoice eq 'Venta Vinculaci%C3%B3n'" ));
    });

    const params = new Promise((resolve, reject) => {
      this.pnpService.getListWithTop('parametrosPaginas', list => {
        const params = list.reduce((params, item) => {
          params[item.CSNombreText] = item.CSValorNote;
          params[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;
          return params;
        }, {});
        resolve(params);
      }, 200, ("CSFormularioChoice eq 'Venta Vinculaci%C3%B3n'" ));
    }
    return Promise.all([configs, params]).then(values => {
      return {
        ...values[0],
        ...values[1]
      };
    })
  }*/
  
}

export default Services; 


// WEBPACK FOOTER //
// ./base/services/services.js